
import store from "../store";
import { gameActions } from '../Game/gameSlice';
import { useEffect, useReducer } from "react";
import { SPRITESHEET_FILE } from "../Enums/ImageAssets";
import { AUDIO_ASSETS, LAZY_AUDIO_ASSETS } from "../Enums/AudioAssets";
import { IMAGE_ASSETS } from "../Enums/ImageAssets";

let preloadedCounter = 0;

function LoadingScreen() {

    const [, forceUpdate] = useReducer(x => x + 1, 0);

    useEffect(() => {

        setInterval(() => {
            preloadedCounter++;
            forceUpdate();
        }, 500);

        let isCancelled = false

        const imageAssetList = Object.keys(IMAGE_ASSETS);
        const audioAssetList = Object.keys(AUDIO_ASSETS);
        const lazyAudioAssetList = Object.keys(LAZY_AUDIO_ASSETS);

        async function effect() {

            if (isCancelled) {
                return
            }

            await preloadImage(SPRITESHEET_FILE);

            for (const image of imageAssetList) {
                await preloadImage(image);
            }

            // loading required sound assets
            for (const audio of audioAssetList) {
                await preloadAudio(audio);
            }

            if (isCancelled) {
                return
            }

            finishLoadingGame();

            // lazy-loading sound assets only after initial loading is done
            for (const audio of lazyAudioAssetList) {
                await preloadAudio(audio);
            }
        };

        effect()

        return () => {
            isCancelled = true
        }
    }, []);

    function printDots(num: number) {
        let dots = '';

        for (let i = 0; i <= num; i++) {
          dots += '.';
        }
        return dots;
      }

    return (
        <div className="loading-screen">
            <div className="loading-screen_text">LOADING{printDots( preloadedCounter % 3)}</div>
        </div>
    );
}

function preloadImage(src: string) {

    return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = function () {
            resolve(img)
        }
        img.onerror = img.onabort = function () {
            reject(src)
        }
        img.src = src
    })
}

function preloadAudio(src: string) {
    return new Promise((resolve, reject) => {
        const audio = new Audio();
        audio.addEventListener('canplaythrough', resolve, false);
        audio.src = src;
    })
}

function finishLoadingGame() {
    store.dispatch(gameActions.loadGame());
}

export default LoadingScreen;
